import { Directive, input, computed } from "@angular/core";
import { cn } from "../utils/utils";

@Directive({
  standalone: true,
  selector: "[agentChatAssistantMessageToolbar]",
  host: {
    "[class]": "computedClass()",
  },
})
export class AgentChatAssistantMessageToolbar {
  readonly inputClass = input<string | undefined>();

  computedClass = computed(() => cn("achat-assistant-toolbar", this.inputClass()));
}
